import { useEffect, useRef } from 'react';
import { Pages } from "../components/layout";
import { concepts } from "fearless-common";
import UserSubscriptions from "./partials/UserSubscriptions";

/** User dashboard page with scroll-to-anchor navigation support on load. */
export default function Dashboard() {
    const ref = useRef<ReturnType<typeof setInterval> | undefined>(undefined);

    useEffect(() => {
        ref.current = setInterval(() => {
            if (window.location.hash) {
                const el = document.getElementById(window.location.hash.replace('#', ''));
                if (el) {
                    clearInterval(ref.current);
                    const yOffset = -100;
                    const y = el.getBoundingClientRect().top + window.scrollY + yOffset;
                    if (y) window.scrollTo({ top: y });
                }
            }
        }, 100);

        return () => {
            clearInterval(ref.current);
        }
    }, [window.location.hash])

    return (
        <Pages.UserBase header={concepts.Subscriptions}>
            <UserSubscriptions />
            <div className="py-vh10" />
        </Pages.UserBase>
    );
}
